module.exports = __webpack_public_path__ + "fonts/icomoon_rrss.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/icomoon_rrss/icomoon_rrss.eot
// module id = hr8X
// module chunks = 1